'use client';

var _excluded = ["className", "disabled", "disableFocusRipple", "fullWidth", "icon", "iconPosition", "indicator", "label", "onChange", "onClick", "onFocus", "selected", "selectionFollowsFocus", "textColor", "value", "wrapped"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as React from 'react';
import clsx from 'clsx';
import composeClasses from '@mui/utils/composeClasses';
import ButtonBase from "../ButtonBase/index.js";
import capitalize from "../utils/capitalize.js";
import { styled } from "../zero-styled/index.js";
import memoTheme from "../utils/memoTheme.js";
import { useDefaultProps } from "../DefaultPropsProvider/index.js";
import unsupportedProp from "../utils/unsupportedProp.js";
import tabClasses, { getTabUtilityClass } from "./tabClasses.js";
import { jsxs as _jsxs } from "react/jsx-runtime";
var useUtilityClasses = function useUtilityClasses(ownerState) {
  var classes = ownerState.classes,
    textColor = ownerState.textColor,
    fullWidth = ownerState.fullWidth,
    wrapped = ownerState.wrapped,
    icon = ownerState.icon,
    label = ownerState.label,
    selected = ownerState.selected,
    disabled = ownerState.disabled;
  var slots = {
    root: ['root', icon && label && 'labelIcon', "textColor".concat(capitalize(textColor)), fullWidth && 'fullWidth', wrapped && 'wrapped', selected && 'selected', disabled && 'disabled'],
    icon: ['iconWrapper', 'icon']
  };
  return composeClasses(slots, getTabUtilityClass, classes);
};
var TabRoot = styled(ButtonBase, {
  name: 'MuiTab',
  slot: 'Root',
  overridesResolver: function overridesResolver(props, styles) {
    var ownerState = props.ownerState;
    return [styles.root, ownerState.label && ownerState.icon && styles.labelIcon, styles["textColor".concat(capitalize(ownerState.textColor))], ownerState.fullWidth && styles.fullWidth, ownerState.wrapped && styles.wrapped, _defineProperty({}, "& .".concat(tabClasses.iconWrapper), styles.iconWrapper), _defineProperty({}, "& .".concat(tabClasses.icon), styles.icon)];
  }
})(memoTheme(function (_ref3) {
  var theme = _ref3.theme;
  return _objectSpread(_objectSpread({}, theme.typography.button), {}, {
    maxWidth: 360,
    minWidth: 90,
    position: 'relative',
    minHeight: 48,
    flexShrink: 0,
    padding: '12px 16px',
    overflow: 'hidden',
    whiteSpace: 'normal',
    textAlign: 'center',
    lineHeight: 1.25,
    variants: [{
      props: function props(_ref4) {
        var ownerState = _ref4.ownerState;
        return ownerState.label && (ownerState.iconPosition === 'top' || ownerState.iconPosition === 'bottom');
      },
      style: {
        flexDirection: 'column'
      }
    }, {
      props: function props(_ref5) {
        var ownerState = _ref5.ownerState;
        return ownerState.label && ownerState.iconPosition !== 'top' && ownerState.iconPosition !== 'bottom';
      },
      style: {
        flexDirection: 'row'
      }
    }, {
      props: function props(_ref6) {
        var ownerState = _ref6.ownerState;
        return ownerState.icon && ownerState.label;
      },
      style: {
        minHeight: 72,
        paddingTop: 9,
        paddingBottom: 9
      }
    }, {
      props: function props(_ref7) {
        var ownerState = _ref7.ownerState,
          iconPosition = _ref7.iconPosition;
        return ownerState.icon && ownerState.label && iconPosition === 'top';
      },
      style: _defineProperty({}, "& > .".concat(tabClasses.icon), {
        marginBottom: 6
      })
    }, {
      props: function props(_ref8) {
        var ownerState = _ref8.ownerState,
          iconPosition = _ref8.iconPosition;
        return ownerState.icon && ownerState.label && iconPosition === 'bottom';
      },
      style: _defineProperty({}, "& > .".concat(tabClasses.icon), {
        marginTop: 6
      })
    }, {
      props: function props(_ref9) {
        var ownerState = _ref9.ownerState,
          iconPosition = _ref9.iconPosition;
        return ownerState.icon && ownerState.label && iconPosition === 'start';
      },
      style: _defineProperty({}, "& > .".concat(tabClasses.icon), {
        marginRight: theme.spacing(1)
      })
    }, {
      props: function props(_ref0) {
        var ownerState = _ref0.ownerState,
          iconPosition = _ref0.iconPosition;
        return ownerState.icon && ownerState.label && iconPosition === 'end';
      },
      style: _defineProperty({}, "& > .".concat(tabClasses.icon), {
        marginLeft: theme.spacing(1)
      })
    }, {
      props: {
        textColor: 'inherit'
      },
      style: _defineProperty(_defineProperty({
        color: 'inherit',
        opacity: 0.6
      }, "&.".concat(tabClasses.selected), {
        opacity: 1
      }), "&.".concat(tabClasses.disabled), {
        opacity: (theme.vars || theme).palette.action.disabledOpacity
      })
    }, {
      props: {
        textColor: 'primary'
      },
      style: _defineProperty(_defineProperty({
        color: (theme.vars || theme).palette.text.secondary
      }, "&.".concat(tabClasses.selected), {
        color: (theme.vars || theme).palette.primary.main
      }), "&.".concat(tabClasses.disabled), {
        color: (theme.vars || theme).palette.text.disabled
      })
    }, {
      props: {
        textColor: 'secondary'
      },
      style: _defineProperty(_defineProperty({
        color: (theme.vars || theme).palette.text.secondary
      }, "&.".concat(tabClasses.selected), {
        color: (theme.vars || theme).palette.secondary.main
      }), "&.".concat(tabClasses.disabled), {
        color: (theme.vars || theme).palette.text.disabled
      })
    }, {
      props: function props(_ref1) {
        var ownerState = _ref1.ownerState;
        return ownerState.fullWidth;
      },
      style: {
        flexShrink: 1,
        flexGrow: 1,
        flexBasis: 0,
        maxWidth: 'none'
      }
    }, {
      props: function props(_ref10) {
        var ownerState = _ref10.ownerState;
        return ownerState.wrapped;
      },
      style: {
        fontSize: theme.typography.pxToRem(12)
      }
    }]
  });
}));
var Tab = /*#__PURE__*/React.forwardRef(function Tab(inProps, ref) {
  var props = useDefaultProps({
    props: inProps,
    name: 'MuiTab'
  });
  var className = props.className,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$disableFocusRi = props.disableFocusRipple,
    disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
    fullWidth = props.fullWidth,
    iconProp = props.icon,
    _props$iconPosition = props.iconPosition,
    iconPosition = _props$iconPosition === void 0 ? 'top' : _props$iconPosition,
    indicator = props.indicator,
    label = props.label,
    onChange = props.onChange,
    onClick = props.onClick,
    onFocus = props.onFocus,
    selected = props.selected,
    selectionFollowsFocus = props.selectionFollowsFocus,
    _props$textColor = props.textColor,
    textColor = _props$textColor === void 0 ? 'inherit' : _props$textColor,
    value = props.value,
    _props$wrapped = props.wrapped,
    wrapped = _props$wrapped === void 0 ? false : _props$wrapped,
    other = _objectWithoutProperties(props, _excluded);
  var ownerState = _objectSpread(_objectSpread({}, props), {}, {
    disabled: disabled,
    disableFocusRipple: disableFocusRipple,
    selected: selected,
    icon: !!iconProp,
    iconPosition: iconPosition,
    label: !!label,
    fullWidth: fullWidth,
    textColor: textColor,
    wrapped: wrapped
  });
  var classes = useUtilityClasses(ownerState);
  var icon = iconProp && label && /*#__PURE__*/React.isValidElement(iconProp) ? /*#__PURE__*/React.cloneElement(iconProp, {
    className: clsx(classes.icon, iconProp.props.className)
  }) : iconProp;
  var handleClick = function handleClick(event) {
    if (!selected && onChange) {
      onChange(event, value);
    }
    if (onClick) {
      onClick(event);
    }
  };
  var handleFocus = function handleFocus(event) {
    if (selectionFollowsFocus && !selected && onChange) {
      onChange(event, value);
    }
    if (onFocus) {
      onFocus(event);
    }
  };
  return /*#__PURE__*/_jsxs(TabRoot, _objectSpread(_objectSpread({
    focusRipple: !disableFocusRipple,
    className: clsx(classes.root, className),
    ref: ref,
    role: "tab",
    "aria-selected": selected,
    disabled: disabled,
    onClick: handleClick,
    onFocus: handleFocus,
    ownerState: ownerState,
    tabIndex: selected ? 0 : -1
  }, other), {}, {
    children: [iconPosition === 'top' || iconPosition === 'start' ? /*#__PURE__*/_jsxs(React.Fragment, {
      children: [icon, label]
    }) : /*#__PURE__*/_jsxs(React.Fragment, {
      children: [label, icon]
    }), indicator]
  }));
});
process.env.NODE_ENV !== "production" ? void 0 : void 0;
export default Tab;